// extracted by mini-css-extract-plugin
export var Container = "styles-module--Container--vR+G0";
export var Container_Image = "styles-module--Container_Image--FSsiI";
export var Container_TextContent = "styles-module--Container_TextContent--KP1Ju";